import { IGetUser, IUserData } from 'types/users/IUser';
import { BaseAPI } from './BaseApi';
import { eAPITags } from './eAPITags';

export const UserApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    getUsersByQuery: build.query<IUserData[], IGetUser[]>({
      query: (query) => ({
        url: `/lender/v2/admin/users/details`,
        method: 'POST',
        body: { users: query },
      }),
      providesTags: (res, err, query) => [{ type: eAPITags.UserListByGetUserQuery, id: JSON.stringify(query) }],
    }),
  }),
});

export const { useGetUsersByQueryQuery } = UserApi;
